module.exports = __webpack_public_path__ + "media/images/icon-hint-a6c5b3da239c670761ad0359c6214839.svg";